
import Vue from "vue";
import ProgressBar from "@/components/ProgressBar.vue";
import {data} from "@/model/Data";

export default Vue.extend({
    name: "App",
    components: {ProgressBar},
    data: () => ({
        step: -1,
        data,
        highestStep: -1,
        anim: "fade",
        isHome: true
    }),

    created() {
        // Forces users to enters in correct route
        if (this.$route.name != "Homepage") this.$router.push("/");
    },

    watch: { // Observer for route changes

        $route (to) { // Changes Progress bar accordingly

            // What is the next index position
            var next: number = this.data.steps.indexOf(to.name);

            // Handles Animation Slide Direction
            if (next < this.step) this.anim = "slider-left";
            else this.anim = "slider-right";

            // Time delay to make animation nicer
            setTimeout(() => this.isHome = to.name == "Homepage", to.name == "Homepage" ? 0 : 350);

            // Set step to next step
            this.step = next;

            history.pushState(null, "", location.href);
            window.onpopstate = function () {
                history.go(1);
            };
        }
    },

    // define methods under the `methods` object
    methods: {
        onStepChanged(step: number) {
            // Update the router
            this.$router.push("/" + this.data.steps[step]);
        },

        unlockStep() {
            // Increments the current step (Bounding it to current max)
            this.step = Math.min(this.step + 1, this.data.steps.length - 1);

            // Sets the highest step reached
            this.highestStep = this.step >= 0 ? Math.max(this.highestStep, this.step) : -1;

            // Reroute to expected step
            this.onStepChanged(this.step);
        },
    },
});
